module.exports = __webpack_public_path__ + "static/media/1.82b6eb52.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/1.wav
// module id = 68
// module chunks = 0